// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DatapointExcelOptionFromJSON(json) {
    return {
        'datapointName': json['datapointName'],
        'columnLabel': !exists(json, 'columnLabel') ? undefined : json['columnLabel'],
        'columnGroupName': !exists(json, 'columnGroupName') ? undefined : json['columnGroupName'],
        'columnSort': !exists(json, 'columnSort') ? undefined : json['columnSort'],
        'columnSortIndex': !exists(json, 'columnSortIndex') ? undefined : json['columnSortIndex'],
        'columnWidth': !exists(json, 'columnWidth') ? undefined : json['columnWidth'],
        'columnIsTotalable': !exists(json, 'columnIsTotalable') ? undefined : json['columnIsTotalable'],
        'hide': !exists(json, 'hide') ? undefined : json['hide'],
    };
}
export function DatapointExcelOptionToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'datapointName': value.datapointName,
        'columnLabel': value.columnLabel,
        'columnGroupName': value.columnGroupName,
        'columnSort': value.columnSort,
        'columnSortIndex': value.columnSortIndex,
        'columnWidth': value.columnWidth,
        'columnIsTotalable': value.columnIsTotalable,
        'hide': value.hide,
    };
}
/**
* @export
* @enum {string}
*/
export var DatapointExcelOptionColumnSortEnum;
(function (DatapointExcelOptionColumnSortEnum) {
    DatapointExcelOptionColumnSortEnum["Asc"] = "Asc";
    DatapointExcelOptionColumnSortEnum["Desc"] = "Desc";
})(DatapointExcelOptionColumnSortEnum || (DatapointExcelOptionColumnSortEnum = {}));
